(ns dashboard.events.google
  (:require
   [re-frame.core :as re-frame]
   [dashboard.interceptors :refer [standard-interceptors]]
   [dashboard.config :refer [google-calendar-api-key]]
   [ajax.core :as ajax]))

(def google-calendar-api-url "https://www.googleapis.com/calendar/v3/calendars/")

(re-frame/reg-event-fx
 ::get-calendar
 standard-interceptors
 (fn [{:keys [db]} [calendar-id]]
   (let [calendar-id (or calendar-id "holiday@group.v.calendar.google.com")
         calendar-region "ja.japanese"]
     {:http-xhrio {:method :get
                   :uri (str google-calendar-api-url calendar-region "%23" calendar-id "/events")
                   :format (ajax/json-request-format)
                   :headers {}
                   :response-format (ajax/json-response-format {:keywords? true})
                   :params  {:key google-calendar-api-key}
                   :on-success [::get-calendar-success]
                   :on-failure [::google-api-fail]}})))

(re-frame/reg-event-fx
 ::get-calendar-success
 standard-interceptors
 (fn [{:keys [db]} [res]]
   {:db (assoc db :google/holidays-jp (:items res))}))

(re-frame/reg-event-fx
 ::google-api-fail
 standard-interceptors
 (fn [{:keys [db]} [res]]
   (js/console.log res)))

(re-frame/reg-sub
 :google/holidays-jp
 (fn [db _]
   (:google/holidays-jp db)))
